import { Box, Typography } from "@mui/material";
import { ReactNode } from "react";
import { colors } from "../../../../../../../ui/colors";

export const CapBadge: React.FC<{
    label: string;
    icon: ReactNode;
    active?: boolean;
}> = ({ label, icon, active = false }) => {
    return (
        <Box
            sx={{
                display: "inline-flex",
                alignItems: "center",
                gap: 0.5,
                px: 1,
                py: 0.45,
                borderRadius: "999px",
                border: `1px solid ${active ? colors.success[50] : colors.gray[100]
                    }`,
                bgcolor: active ? "rgba(16, 185, 129, 0.06)" : colors.gray[50],
                color: active ? colors.success[500] : colors.gray[300],
                fontSize: 11,
                fontWeight: 700,
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    "& svg": {
                        fontSize: 13,
                        color: active ? colors.success[500] : colors.gray[300],
                    },
                }}
            >
                {icon}
            </Box>

            <Typography
                component="span"
                sx={{
                    fontSize: 11,
                    fontWeight: 700,
                    color: active ? colors.success[500] : colors.gray[300],
                }}
            >
                {label}
            </Typography>
        </Box>
    );
};